import { render, staticRenderFns } from "./AddSPTPage.vue?vue&type=template&id=028bd7ba&scoped=true&"
import script from "./AddSPTPage.vue?vue&type=script&lang=js&"
export * from "./AddSPTPage.vue?vue&type=script&lang=js&"
import style0 from "./AddSPTPage.vue?vue&type=style&index=0&id=028bd7ba&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "028bd7ba",
  null
  
)

export default component.exports